export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10460.d4d6f6bf.jpg";